import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ADRES_KONTAKTOWY } from '../config/kontakt'
import { useTranslation } from 'react-i18next'
import { jestPolska } from '../kraj'

// Kotwica to `id` nagłówka o cookies w polityce (slugify z Markdown.jsx): w Polsce
// „8. Pliki cookies”, w Rumunii „8. Fișiere cookie” z public/legal/ro/polityka-prywatnosci.md.
// Zmiana numeru lub tytułu tego rozdziału w którymkolwiek pliku wymaga poprawki tutaj.
const KOTWICA_COOKIES = jestPolska ? '8-pliki-cookies' : '8-fisiere-cookie'

// Narzędzia na całą wysokość okna (scena 3D z panelem): stopka przylega do nich. Odstęp `mt-20` dawał tam
// po przewinięciu pusty, jasny pas pod modelem.
const PELNY_EKRAN = ['/projekt-3d']

// Narzędzia, które liczą, dobierają albo wypełniają dane automatycznie. Na nich stopka ma jedną
// drobną, szarą linijkę, że wynik trzeba sprawdzić (regulamin § 8 ust. 6–8). Celowo w stopce, a nie na
// stronach narzędzi: nie zmienia ich układu, a nowe narzędzie wystarczy dopisać tutaj.
const NARZEDZIA = [
  '/dobor-zestawu-pv', '/dobierz-zestaw', '/potwierdzenie-zestawu',
  '/dobor-falownika', '/dobor-modulow', '/dobor-magazynu', '/dobor-ladowarki',
  '/kompatybilnosc', '/sprawdz-oferte', '/zgloszenie-mikroinstalacji', '/zawiadomienie-psp',
  '/projekt-3d', '/teczka-pme2', '/pulpit', '/klienci',
]
const jestNarzedziem = (sciezka) => NARZEDZIA.some((n) => sciezka === n || sciezka.startsWith(`${n}/`))

const Footer = () => {
  const { t } = useTranslation('wspolne')
  const { pathname } = useLocation()
  const sciezka = pathname.replace(/\/+$/, '')
  const przylega = PELNY_EKRAN.includes(sciezka)
  return (
    <footer className={`bg-black text-white ${przylega ? '' : 'mt-20'}`}>
      <div className='max-w-7xl mx-auto px-4 md:px-8 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs'>
        <p className='text-gray-400'>&copy; 2024&ndash;2026 VoltValue&trade;. {t('stopka.prawa')}</p>
        <div className='flex flex-wrap items-center justify-center gap-x-6 gap-y-2'>
          {/* Adres kontaktowy w stopce, czyli tam, gdzie się go szuka. `mailto:`,
              nie sam napis — na telefonie otwiera pocztę jednym dotknięciem. */}
          <a href={`mailto:${ADRES_KONTAKTOWY}`} className='text-gray-300 hover:text-white hover:underline'>
            {ADRES_KONTAKTOWY}
          </a>
          {/* Program dla instalatorów działa tylko w Polsce. */}
          {jestPolska && (<Link to='/dla-firm' className='text-gray-300 hover:text-white hover:underline'>{t('stopka.dla_wykonawcow')}</Link>)}
          {/* Cennik planów dla firm (FE-11): konta i plany są tylko w Polsce. */}
          {jestPolska && (<Link to='/cennik' className='text-gray-300 hover:text-white hover:underline'>Cennik</Link>)}
          <Link to='/regulamin' className='text-gray-300 hover:text-white hover:underline'>{t('stopka.regulamin')}</Link>
          <Link to='/polityka-prywatnosci' className='text-gray-300 hover:text-white hover:underline'>{t('stopka.polityka')}</Link>
          <Link to={`/polityka-prywatnosci#${KOTWICA_COOKIES}`} className='text-gray-300 hover:text-white hover:underline'>{t('stopka.cookies')}</Link>
        </div>
      </div>
      {jestNarzedziem(sciezka) && (
        <p className='max-w-7xl mx-auto px-4 md:px-8 pb-3 text-[11px] leading-4 text-gray-500 text-center sm:text-left'>
          {t('stopka.sprawdz_wyniki')}
        </p>
      )}
    </footer>
  )
}

export default Footer
